import { render, staticRenderFns } from "./CardUserProfile.vue?vue&type=template&id=60dd46ea"
import script from "./CardUserProfile.vue?vue&type=script&lang=js"
export * from "./CardUserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports